module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui vertical inverted sticky menu fixed top"
  }, [_c('router-link', {
    staticClass: "item logo",
    attrs: {
      "to": {
        name: 'welcome'
      }
    }
  }, [_c('img', {
    staticClass: "ui small centered image",
    attrs: {
      "src": require("./../assets/logo.png")
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'AccordionDoc'
      }
    }
  }, [_vm._v("\n        Accordion\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'DimmerDoc'
      }
    }
  }, [_vm._v("\n        Dimmer\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'DropDownDoc'
      }
    }
  }, [_vm._v("\n        Dropdown\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'EmbedDoc'
      }
    }
  }, [_vm._v("\n        Embed\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'ModalDoc'
      }
    }
  }, [_vm._v("\n        Modal\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'PopupDoc'
      }
    }
  }, [_vm._v("\n        Popup\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'ProgressDoc'
      }
    }
  }, [_vm._v("\n        Progress\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'RatingDoc'
      }
    }
  }, [_vm._v("\n        Rating\n    ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e336de90"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppMenu.vue
// module id = 157
// module chunks = 1